import React from "react";
import "./UpcomingEvent.css";

const UpcomingEvent = ({ data }) => {
  return (
    <div className="Pathway">
      <div className="Pathway-box landing-pages">
        <p className="founder-subtitle">{data?.uceventSubtitle}</p>

        <h2 className="founder-title">
           {data?.uceventTitle?.split(" ").slice(0, -1).join(" ")}
        <span> {data?.uceventTitle?.split(" ").slice(-1).join(" ")}</span>
        </h2>

        <p className="event-date">{data?.uceventDate}</p>

        <p className="event-desc">{data?.uceventDescription}</p>
      </div>
    </div>
  );
};

export default UpcomingEvent;
